import { createImmerReducer } from "utils/ReducerUtils";
import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

import type { FlattenedDSL } from "@shared/dsl";
import { flattenDSL } from "@shared/dsl";
import type { WidgetProps } from "widgets/BaseWidget";

export interface CurrentPageDraftReduxState {
  [pageId: string]: {
    dsl: FlattenedDSL<WidgetProps>;
    layoutId: string;
  };
}

const initialState: CurrentPageDraftReduxState = {};

const pageDraftReducer = createImmerReducer(initialState, {
  // Reducer to clear all pageWidgets before finishing creating
  // a new application

  [ReduxActionTypes.FETCH_DRAFT_DSLS_SUCCESS]: (
    state: CurrentPageDraftReduxState,
    action: ReduxAction<
      Array<{ pageId: string; dsl: WidgetProps; layoutId: string }>
    >,
  ) => {
    action.payload.forEach((entry) => {
      state[entry.pageId] = { dsl: entry.dsl, layoutId: entry.layoutId };
    });
  },

  [ReduxActionTypes.FETCH_DRAFT_DSL_SUCCESS]: (
    state: CurrentPageDraftReduxState,
    action: ReduxAction<{
      pageId: string;
      dsl?: WidgetProps;
      layoutId: string;
    }>,
  ) => {
    if (!action.payload.dsl) {
      delete state[action.payload.pageId];
    } else {
      state[action.payload.pageId] = { dsl: action.payload.dsl, layoutId: action.payload.layoutId };
    }
  },

  [ReduxActionTypes.FETCH_PUBLISHED_DRAFT_DSL_SUCCESS]: (
    state: CurrentPageDraftReduxState,
    action: ReduxAction<{
      pageId: string;
      dsl?: WidgetProps;
      layoutId: string;
    }>,
  ) => {
    if (!action.payload.dsl) {
      delete state[action.payload.pageId];
    } else {
      state[action.payload.pageId] = { dsl: action.payload.dsl, layoutId: action.payload.layoutId };
    }
  },


});

export default pageDraftReducer;
